var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { listen, memoize } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPPlugin } from '../../core/base/plugin';
import { UIPSnippets } from '../snippets/snippets';
import './snippets-title.shape';
/** Common lightweight plugin to display currently selected snippet title */
export class UIPSnippetsTitle extends UIPPlugin {
    get $root() {
        const parent = this.closest(`${UIPSnippets.is}`);
        if (parent)
            return parent.$root;
        return super.$root;
    }
    /** Active snippet title inner element */
    get $inner() {
        const type = this.constructor;
        return React.createElement("span", { className: type.is + '-inner' });
    }
    connectedCallback() {
        super.connectedCallback();
        this.appendChild(this.$inner);
        setTimeout(() => this._onRootStateChange());
    }
    /** Handles active snippet title change */
    _onRootStateChange() {
        var _a;
        this.$inner.textContent = ((_a = this.model.activeSnippet) === null || _a === void 0 ? void 0 : _a.label) || '';
    }
}
UIPSnippetsTitle.is = 'uip-snippets-title';
__decorate([
    memoize()
], UIPSnippetsTitle.prototype, "$root", null);
__decorate([
    memoize()
], UIPSnippetsTitle.prototype, "$inner", null);
__decorate([
    listen({ event: 'uip:snippet:change', target: ($this) => $this.$root })
], UIPSnippetsTitle.prototype, "_onRootStateChange", null);
